import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import TemplateDefault from "../../components/template-default";
import Card from "../../components/card";
import Button from "../../components/button";
import InputForm from "../../components/input-form";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../utils/localization-ag-grid";

import {FaPlusSquare} from "react-icons/fa";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css"
import {useQuery} from "@tanstack/react-query";
import projectService from "../../services/project-service";
import {useNavigate} from "react-router-dom";
import phoneRender from "../dashboard/components/phone-render";
import {buildAccentInsensitiveColDef, setAccentInsensitiveQuickFilter} from "../../utils/ag-grid-quick-filter";

const Project = () => {
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "SISTEMA INTERNO";
    }, []);

    const {data: projects} = useQuery({
        queryFn: () => projectService.list().then(({data}) => data),
        queryKey: ['projects']
    });

    const [columnDefs] = useState([
        { field: "code", headerName: "ID" },
        { field: "name", headerName: "Nome", flex: 1, minWidth: 200 },
        { field: "phone", headerName: "Telefone", cellRenderer: phoneRender },
        { field: "resales_names", headerName: "Revendas", flex: 2, minWidth: 250 }
    ]);

    const gridRef = useRef();

    const defaultColDef = useMemo(() => {
        return buildAccentInsensitiveColDef({resizable: false});
    }, []);

    const onFilterTextBoxChanged = useCallback(({target}) => {
        setAccentInsensitiveQuickFilter(gridRef, target.value);
    }, []);

    const onCellClicked = (cell) => {
        if (cell.colDef.field !== "phone") navigate(`/projects/form/${cell.data.id}`)
    };

    return (
        <TemplateDefault title="Projetos">
            <Card>
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-12">
                    <Button col="col-span-3" onClick={() => navigate("/projects/form")}>
                        <FaPlusSquare/> Novo projeto
                    </Button>

                    <InputForm id="search" col="col-span-9" label="Pesquisar" type="search" onChange={onFilterTextBoxChanged}/>
                </div>

                <div className={"ag-theme-quartz grid mt-4"} style={{height: "calc(100vh - 185px)"}}>
                    <AgGridReact
                        ref={gridRef}
                        rowHeight={32}
                        rowData={projects}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        pagination
                        paginationPageSize={500}
                        paginationPageSizeSelector={[20, 50, 100, 500]}
                        animateRows={false}
                        suppressRowClickSelection={true}
                        suppressCellFocus={true}
                        onCellClicked={onCellClicked}
                        gridOptions={{localeText: LocalizationAgGrid}}
                    />
                </div>
            </Card>
        </TemplateDefault>
    );
};

export default Project;
